/**
 * The following scripts get applied on the frontend of your site.
 */

jQuery(document).ready(function ($) {

    // open accordion on click
    $('body').on('click', '.accordion > .title', function (e) {
        e.preventDefault();

        var isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);

        $(this).next('.description').stop().slideToggle(400, function () {
            var isHidden = $(this).attr('aria-hidden') === 'true';
            $(this).attr('aria-hidden', !isHidden);
            $(this).parent().stop();
        });
    });

    // open accordion on keypress
    $('body').on('keypress', '.accordion > .title', function (e) {
        e.preventDefault();
        if (e.target !== this) return;
        if (e.code == "Enter" || e.keyCode == 13 || e.code == "Space" || e.keyCode == 32) {
            $(this).trigger('click');
        }
    });

    // open accordion with url hash
    if (window.location.hash) {
        const hash = window.location.hash;
        $(`.accordion${hash}`).each(function () {
            $(this).get(0).scrollIntoView({ behavior: 'smooth' });
            if ($(this).find('.title').attr('aria-expanded') !== true) {
                $(this).find('.title').trigger('click');
            }
        })
    }
});